import SelectedStoreBase from "~/state/modules/selectedStoreBase";
import SingleSelectedProperty from "~/state/modules/singleSelectedProperty";
import User from "~/models/user";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import ObjectModel from "~/models/objectModel";

export default class Selected extends SelectedStoreBase {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static objectModel = new SingleSelectedProperty('objectModel', () => ObjectModel);
  static objectModelEntry = new SingleSelectedProperty('objectModelEntry', () => ObjectModelEntry);
}